import {
  Board,
  BoardTableContainer,
} from "../../assets/GlobalStyles";
import Table from "../../components/table";
import React, {useEffect, useState} from "react";
import {atom, useAtom} from "jotai";
import {dataTotalInfo} from "../../components/common/entity";
import {selPolicyTerms} from "../../services/Platform/TermsAxios";
import {columnTermData} from "./entity/Common";
import PlatformSectionHeader from "./PlatformSectionHeader";
import styled from "styled-components";

const termList = atom([])
export default function PlatformTerm(){
  const [termList, setTermList] = useState([])
  const [totalInfo,setTotalInfo] = useState(dataTotalInfo)

  useEffect(()=>{
    selPolicyTerms().then(response =>{

      if(response !== null){
        setTermList(response)
        setTotalInfo({
          totalCount: response.length,
          totalPages: response.length,
          currentPage:response.length
        })
      }
    })
  },[])


  return(
    <>
    <TermConditionCard>
      <PlatformSectionHeader title="조회 조건" description="현재 등록된 전체 약관을 기준으로 목록을 조회합니다."/>
    </TermConditionCard>
    <Board>
      <PlatformSectionHeader title="약관 목록" description="등록된 약관의 유형과 적용 정보를 확인합니다." count={totalInfo.totalCount ?? 0} unit="건"/>
      <TermTableContainer>
        <Table columns={columnTermData}
               data={termList !== null ? termList : []}/>
      </TermTableContainer>
    </Board>
    </>
  )
}

const TermTableContainer = styled(BoardTableContainer)`
  && > section > div:last-child {
    border:1px solid #e5e8eb !important;
    border-radius:8px !important;
    box-shadow:none !important;
  }
  && .InovuaReactDataGrid {border:0 !important;border-radius:0 !important;box-shadow:none !important;}
`;

const TermConditionCard = styled(Board)`
  margin-bottom: 0;
`;
